// extracted by mini-css-extract-plugin
export var container = "SlideTransition-module--container--1M1p5";
export var inner = "SlideTransition-module--inner--7qC0r";